import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesClientes {
  ler: boolean;
  criar: boolean;
  atualizar: boolean;
  excluir: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `clientes`
 * (ADR 011 — docs/architecture/011-rbac-recurso-clientes.md):
 * `admin` tem as 4 ações (via curinga `*`); `financeiro`/`suporte`/
 * `marketing` têm só `ler` (migration `006_rbac_clientes.sql`);
 * `producao`/`parceiros` não têm nenhuma. Usado apenas para decidir o
 * que mostrar na UI (ex: esconder "Novo cliente") — a autorização real
 * é sempre revalidada pelo backend em cada requisição; esta função
 * nunca é a fonte de verdade de permissão, só evita mostrar uma ação
 * que o backend rejeitaria com 403.
 */
export function permissoesClientes(papel: PapelUsuario): PermissoesClientes {
  if (papel === 'admin') {
    return { ler: true, criar: true, atualizar: true, excluir: true };
  }
  if (papel === 'financeiro' || papel === 'suporte' || papel === 'marketing') {
    return { ler: true, criar: false, atualizar: false, excluir: false };
  }
  return { ler: false, criar: false, atualizar: false, excluir: false };
}
